import { Text } from "@radix-ui/themes";
import { motion } from "framer-motion";

// Tags selection step
export const FallingPictures = ({
  pictures,
}: {
  pictures: {
    src: string;
    text: string;
  }[];
}) => {
  pictures = [
    {
      src: "/images/testimonies/testimony_gregoire.webp",
      text: "Grégoire",
    },
    {
      src: "/images/testimonies/testimony_ilya.jpg",
      text: "Ilya",
    },
    {
      src: "/images/testimonies/testimony_thibault.jpg",
      text: "Thibault",
    },
    {
      src: "/images/testimonies/testimony_cassandre.jpg",
      text: "Cassandre",
    },
    {
      src: "/images/testimonies/testimony_martin.jpg",
      text: "Martin",
    },
    {
      src: "/images/testimonies/testimony_cyril.webp",
      text: "Cyril",
    },
    {
      src: "/images/testimonies/testimony_claude.jpg",
      text: "Claude",
    },
  ];

  const randomScale = [0.9, 1, 1.2, 0.6, 1.4, 1.3, 1.5, 0.7, 0.8, 0.95];
  const randomScale2 = [0.9, 1.1, 0.8, 1.5, 1.2, 1.4, 0.6, 0.8, 0.7, 0.85];
  const randomAngles = [0, 5, -5, 10, -10, 15, -15, 20, -20, 25];
  const randomDelay = [0.1, 0.4, 0.7, 1.0, 1.2, 1.4, 1.6, 1.8, 2.0, 2.2];

  return (
    <>
      {pictures.map((picture, i) => (
        <div
          key={i}
          style={{
            zIndex: 1,
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: `translate(${-50 * randomScale[i]}%, ${
              -50 * randomScale2[i]
            }%) rotateZ(${randomAngles[i]}deg)`,
          }}
        >
          <motion.div
            style={{
              zIndex: 10 + i,
              animationDelay: `${randomDelay[i]}s`,
              animationDuration: "0.3s",
            }}
            className="bg-white p-2 pb-0 flex flex-col w-64 mx-auto my-6 falling-photo-animated shadow-lg"
          >
            <img
              src={picture.src}
              className="w-full aspect-[9/10] object-top object-cover"
              alt={picture.text}
            />
            <Text size="1" className="text-black py-3 w-full text-center">
              <span className="capitalize">{picture.text}</span>
            </Text>
          </motion.div>
        </div>
      ))}
    </>
  );
};
